import React from 'react';
import { useTranslations } from '../../locales/useTranslations';
import FadeInAnimation from '../Common/FadeInAnimation';
import { BiCheckCircle, BiDownload, BiCodeAlt, BiPlug } from 'react-icons/bi';

const WooCommerceSchnittstelleHeader = () => {
    const { t } = useTranslations();

    return (
        <section className="wc-header">
            <div className="wc-header__decoration wc-header__decoration--top"></div>
            <div className="wc-header__decoration wc-header__decoration--bottom"></div>

            <div className="container wc-header__content">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12">
                        <FadeInAnimation direction="right" delay={50}>
                            <div>
                                <span className="wc-header__badge">
                                    {t('woocommerceSchnittstelle_header_badge') || 'WooCommerce Plugin'}
                                </span>

                                <h1 className="wc-header__title">
                                    {t('woocommerceSchnittstelle_header_title')}
                                </h1>

                                <p className="wc-header__description">
                                    {t('woocommerceSchnittstelle_header_description')}
                                </p>

                                <div className="wc-header__features">
                                    <div className="wc-header__feature-item">
                                        <BiCheckCircle />
                                        <span>{t('woocommerceSchnittstelle_header_feature1')}</span>
                                    </div>
                                    <div className="wc-header__feature-item">
                                        <BiCheckCircle />
                                        <span>{t('woocommerceSchnittstelle_header_feature2') || 'XML & JSON Export'}</span>
                                    </div>
                                    <div className="wc-header__feature-item">
                                        <BiCheckCircle />
                                        <span>{t('woocommerceSchnittstelle_header_feature3')}</span>
                                    </div>
                                </div>

                                <div className="wc-header__buttons">
                                    <a href="#pricing" className="wc-header__btn-primary">
                                        {t('woocommerceSchnittstelle_header_cta')}
                                    </a>
                                    <a href="#features" className="wc-header__btn-secondary">
                                        {t('woocommerceSchnittstelle_header_cta2')}
                                    </a>
                                </div>
                            </div>
                        </FadeInAnimation>
                    </div>

                    <div className="col-lg-6 col-md-12 wc-header__cards-column">
                        <FadeInAnimation direction="left" delay={100}>
                            <div className="wc-header__cards-grid">
                                <div className="wc-header__card">
                                    <BiDownload />
                                    <h3>{t('woocommerceSchnittstelle_header_xml_export')}</h3>
                                    <p>{t('woocommerceSchnittstelle_header_xml_export_desc')}</p>
                                </div>
                                <div className="wc-header__card">
                                    <BiCodeAlt />
                                    <h3>{t('woocommerceSchnittstelle_header_json_export')}</h3>
                                    <p>{t('woocommerceSchnittstelle_header_json_export_desc')}</p>
                                </div>
                                <div className="wc-header__card">
                                    <BiPlug />
                                    <h3>{t('woocommerceSchnittstelle_header_webhook_integration')}</h3>
                                    <p>{t('woocommerceSchnittstelle_header_webhook_integration_desc')}</p>
                                </div>
                                <div className="wc-header__card wc-header__card--highlight">
                                    <div className="wc-header__price">
                                        {t('woocommerceSchnittstelle_header_price')}
                                    </div>
                                    <p className="wc-header__price-desc">
                                        {t('woocommerceSchnittstelle_header_price_desc')}
                                    </p>
                                </div>
                            </div>
                        </FadeInAnimation>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WooCommerceSchnittstelleHeader;
